var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLocationAwayLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8761_19682)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.29 15.0171L23.4 11.3271C24.2 10.6071 25.42 10.6071 26.22 11.3271L32.86 17.2771C33.53 17.8771 33.91 18.7371 33.91 19.6271V27.6671C33.91 29.6571 32.3 31.2671 30.31 31.2671H25.58",
    stroke: "#121619",
    strokeWidth: 2.2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6201 13.4863L37.0901 21.0863",
    stroke: "#121619",
    strokeWidth: 2.2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0195 19.8965H27.5895",
    stroke: "#121619",
    strokeWidth: 2.2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8398 15.487V10.667",
    stroke: "#121619",
    strokeWidth: 2.2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0796 23.4366C17.5873 23.4366 18.8096 22.2143 18.8096 20.7066C18.8096 19.1988 17.5873 17.9766 16.0796 17.9766C14.5719 17.9766 13.3496 19.1988 13.3496 20.7066C13.3496 22.2143 14.5719 23.4366 16.0796 23.4366Z",
    stroke: "#121619",
    strokeWidth: 2.2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5499 32.3866V29.3266C21.5499 28.6066 20.9599 28.0166 20.2399 28.0166H11.9399C11.2199 28.0166 10.6299 28.6066 10.6299 29.3266V32.3866",
    stroke: "#121619",
    strokeWidth: 2.2,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8761_19682"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLocationAwayLight);
export default __webpack_public_path__ + "static/media/icon_location_away_light.b5d11994.svg";
export { ForwardRef as ReactComponent };